/**
 * Universal tagging — frontend mirror of the entity-type registry: how to
 * NAVIGATE to a record of each type. Backend registry (src/config/tagEntityTypes.js)
 * knows tables/columns; this file knows portal routes.
 *
 * ProjectPage routes on `#<menuId>` (hash) and reads `?tag=<id>` to preselect
 * the tracker's tag filter and `?mechTable=<id>` to preselect the mechanical
 * sub-table dropdown.
 */

const ENTITY_LINKS = {
  tracker_piping: { menuId: 'matrix' },
  hvac_tracking: { menuId: 'hvac' },
  structural_steel_tracking: { menuId: 'structure' },
  rotating_equipment_tracking: { menuId: 'mechanical-rotating-eqp', mechTable: 'rotating-equipment' },
  vessels_tracking: { menuId: 'mechanical-vessels', mechTable: 'vessels' },
  chutes_tracking: { menuId: 'mechanical-rotating-eqp', mechTable: 'chutes' },
  conveyors_tracking: { menuId: 'mechanical-rotating-eqp', mechTable: 'conveyors' },
  skids_tracking: { menuId: 'mechanical-rotating-eqp', mechTable: 'skids' },
  ducts_tracking: { menuId: 'mechanical-ducts' },
  boilermaker_tracking: { menuId: 'boilermaker' },
  civil_tracking: { menuId: 'civil' },
  electrical_tracking: { menuId: 'electrical' },
};

/**
 * URL that opens the module where this record lives, pre-filtered to the tag.
 * Returns null when the record type has no route yet or project is unknown.
 */
export function buildTagEntityUrl(entityType, projectId, tagId) {
  const link = ENTITY_LINKS[entityType];
  if (!link || projectId == null) return null;
  const params = new URLSearchParams();
  if (tagId != null) params.set('tag', String(tagId));
  if (link.mechTable) params.set('mechTable', link.mechTable);
  const qs = params.toString();
  return `/project/${projectId}${qs ? `?${qs}` : ''}#${link.menuId}`;
}

export function hasTagEntityLink(entityType) {
  return !!ENTITY_LINKS[entityType];
}
